module.exports = __webpack_public_path__ + "static/media/ETH-logo.37e4f26b.png";